<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <c-form>
                    <c-form-item type="input" label="姓名" name="name"></c-form-item>
                    <c-form-item type="input" label="电话" name="phone"></c-form-item>
                    <c-form-item type="input" label="公司" name="company"></c-form-item>
                    <c-form-item type="checkbox" name="state" :options="templateState"></c-form-item>
                </c-form>
            </m-search>

            <c-table ref="table">
                <c-table-column
                        label="状态"
                        name="state"
                >
                    <template v-slot="{data}">
                        <span v-if="data.state==1" style="color: red">待处理</span>
                        <span v-if="data.state==2" style="color: green">已处理</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="姓名"
                        name="name"
                >
                </c-table-column>

                <c-table-column
                        label="电话"
                        name="phone"
                >
                </c-table-column>

                <c-table-column
                        label="公司"
                        name="company"
                >
                </c-table-column>

                <c-table-column
                        label="邮箱"
                        name="email"
                >
                </c-table-column>

                <c-table-column
                        label="地址"
                        name="address"
                >
                </c-table-column>

                <c-table-column
                        label="提交时间"
                        name="create_date"
                >
                </c-table-column>

                <c-table-column
                        label="处理人"
                        name="deal_user_realname"
                >
                </c-table-column>
                <c-table-column
                        label="处理时间"
                        name="deal_date"
                >
                </c-table-column>

                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="110"
                >
                    <template v-slot="row">
                        <c-table-button power="b_custom_detail" @click="navigateTo(`/website/service/custom/detail/${row.data.id}`)">查看</c-table-button>
                        <c-table-button v-if="row.data.state == 1" power="b_custom_deal" @click="navigateTo(`/website/service/custom/detail/${row.data.id}`)">处理</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </module>
    </page>
</template>

<script>
var name = 'm_custom';
var urls = {
    list: '/website/feedback/list' //列表数据
}
export default {
    name: name,

    data() {
        return {
            detailData: {},
            img_list:[],
            templateState: [{
                name: '待处理',
                value: 1
            }, {
                name: '已处理',
                value: 2
            }]
        }
    },

    mounted() {
        this.$refs.search.search();

        this.$bus.$on(name + '.update', page => {
            this.$refs.table.update(page);
        });
    },

    methods: {
        searchHandle(data) {
            data.type = 1;
            this.$refs.table.load({
                url: urls.list,
                data
            });
        }
    }
}
</script>